import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/marketing',
    name: 'Marketing',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing.vue')
  },
  {
    path: '/preflight',
    name: 'Preflight',
    component: () => import(/* webpackChunkName: "preflight" */ '../views/Preflight.vue')
  },
  {
    path: '/kora-status',
    name: 'KoraStatus',
    component: () => import(/* webpackChunkName: "kora-status" */ '../views/KoraStatus.vue')
  },
  {
    path: '/oc-users',
    name: 'OcUsers',
    component: () => import(/* webpackChunkName: "oc-users" */ '../views/OcUsers.vue')
  },
  {
    path: '/in-app-numbers',
    name: 'InAppNumbers',
    component: () => import(/* webpackChunkName: "in-app-numbers" */ '../views/InAppNumbers.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
 linkExactActiveClass: "active",
  routes
})

export default router
